export enum StepOutput {
    audiologist = 'audiologist',
    caroBodyWeightMeasurement = 'caroBodyWeightMeasurement',
    caroQuestionnaire = 'caroQuestionnaire',
    close = 'close',
    continue = 'continue',
    dietitian = 'dietitian',
    entSpecialist = 'entSpecialist',
    false = 'false',
    handover = 'handover',
    lifestyleCoach = 'lifestyleCoach',
    mdo = 'mdo',
    no = 'no',
    nurseSpecialist = 'nurseSpecialist',
    pause = 'pause',
    psychologist = 'psychologist',
    referral = 'referral',
    secretarialAssistant = 'secretarialAssistant',
    stop = 'stop',
    successful = 'successful',
    true = 'true',
    yes = 'yes',
}
